import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';

import {
  FormLabel, Select, MenuItem, FormControl,
} from '@mui/material';
import get from 'lodash/get';
import toPairs from 'lodash/toPairs';
import isEmpty from 'lodash/isEmpty';

import marketActions from '../../actions/markets';
import WrappedSpinner from './wrapped-spinner';

const styles = {
  formLabel: {
    textAlign: 'center',
    width: '100%',
  },
};

class BaseBrandSelect extends React.Component {
  constructor(props) {
    super(props);

    const { value } = props;

    this.state = {
      selectedBrand: value.toUpperCase(),
    };

    this.handleChange = this.handleChange.bind(this);
  }

  async componentDidMount() {
    const { fetchMarketBrands, brands } = this.props;
    const dataToFetch = [];
    if (!brands || isEmpty(brands)) dataToFetch.push(fetchMarketBrands());

    await Promise.all(dataToFetch);
  }

  handleChange(event) {
    const { brands, handleChange, returnBrandKey } = this.props;
    const brandKey = event.target.value;
    const stateUpdate = { [event.target.name]: event.target.value };
    this.setState(stateUpdate);

    const value = returnBrandKey ? brandKey : brands[brandKey];
    handleChange(value);
  }

  render() {
    const {
      brands, marketsLoading, showAll, disabled,
    } = this.props;
    const { selectedBrand } = this.state;

    const displayedBrand = get(
      toPairs(brands).find(([brand]) => brand.toUpperCase() === selectedBrand),
      '[0]',
      '',
    );

    return (
      <WrappedSpinner isLoading={marketsLoading}>
        <FormControl
          component="fieldset"
          style={{ width: '100%' }}
        >
          <FormLabel
            component="legend"
            style={styles.formLabel}
          >
            Brand
          </FormLabel>
          <Select
            displayEmpty
            disabled={disabled}
            style={{ width: '100%' }}
            onChange={this.handleChange}
            value={displayedBrand}
            variant="standard"
            inputProps={{
              name: 'selectedBrand',
              id: 'brand-picker',
            }}
          >
            {showAll && (
              <MenuItem
                value=""
                key="none"
              >
                All
              </MenuItem>
            )}
            {brands
              && toPairs(brands).map(([key, name]) => (
                <MenuItem
                  value={key}
                  key={key}
                >
                  {name}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
      </WrappedSpinner>
    );
  }
}
BaseBrandSelect.defaultProps = {
  value: '',
  brands: {},
  marketsLoading: false,
  returnBrandKey: true,
  showAll: true,
  disabled: false,
};
BaseBrandSelect.propTypes = {
  handleChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  brands: PropTypes.objectOf(PropTypes.string),
  marketsLoading: PropTypes.bool,
  returnBrandKey: PropTypes.bool,
  showAll: PropTypes.bool,
  disabled: PropTypes.bool,
};

const mapStateToProps = ({ markets }) => ({
  brands: markets.marketBrands,
  marketsLoading: markets.isLoading,
});

const mapDispatchToProps = (dispatch) => bindActionCreators(
  {
    fetchMarketBrands: marketActions.fetchMarketBrands,
  },
  dispatch,
);

const BrandSelect = connect(
  mapStateToProps,
  mapDispatchToProps,
)(BaseBrandSelect);

export { BrandSelect, BaseBrandSelect };
